import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.037 12.41" {...props}><path data-name="Path 3805" d="M9.667 10.979C6.507 15.179 2.695 8.937 0 7.624c3.548-1.843 9.9-3.151 10.039 2.584" fill="#34c759" /><path data-name="Path 3806" d="M10.432 9.411C8.101.865 18.199-.398 24.037.091c-2.113 1.626-2.8 4.3-3.768 6.6-1.483 3.3-4.594 6.883-8.374 4.362" fill="#1f7a3c" /></svg>);